import React from "react";

/**
 * Metric — small labelled value tile used inside dashboard cards (e.g.
 * Avg TTFT / Avg TTFB / Errors inside AssistantPerformanceCard).
 *
 * `tone`:
 *   "default" — neutral on-surface colour
 *   "ok"      — emerald (positive metric, e.g. Booked)
 *   "warn"    — red (negative metric, e.g. Errors > 0)
 */
const Metric = ({ label, value, tone = "default" }) => {
  const toneClass =
    tone === "warn"
      ? "text-red-600 dark:text-red-400"
      : tone === "ok"
        ? "text-emerald-600 dark:text-emerald-400"
        : "text-on-surface-light dark:text-on-surface";
  return (
    <div className="rounded-lg bg-surface-light-low dark:bg-surface-container-low border border-surface-light-highest dark:border-white/5 p-3">
      <p className="text-[11px] text-on-surface-light-variant dark:text-on-surface-variant uppercase tracking-wider">
        {label}
      </p>
      <p className={`font-display text-lg font-semibold ${toneClass}`}>
        {value}
      </p>
    </div>
  );
};

export default Metric;
